// Helper to get first field name from a nested errors object
const getFirstErrorFieldName = (
  errors: Record<string, unknown>,
  prefix = '',
): string | null => {
  for (const key of Object.keys(errors)) {
    const fieldName = prefix ? `${prefix}.${key}` : key;
    const value = errors[key];

    if (typeof value === 'string') {
      return fieldName;
    } else if (typeof value === 'object' && value !== null) {
      const nestedResult = getFirstErrorFieldName(
        value as Record<string, unknown>,
        fieldName,
      );
      if (nestedResult) return nestedResult;
    }
  }
  return null;
};

/**
 * Scrolls to the first form field with a validation error and focuses it.
 * Useful for long forms where validation errors may be out of viewport.
 *
 * @param errors - The errors object from react-final-form
 */
export const scrollToFirstError = (errors: Record<string, unknown>): void => {
  const firstErrorField = getFirstErrorFieldName(errors);

  if (firstErrorField) {
    const element =
      document.querySelector(`[name="${firstErrorField}"]`) ||
      document.getElementById(firstErrorField);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });

      if (element instanceof HTMLElement) {
        setTimeout(() => element.focus(), 300);
      }
    }
  }
};
